import { create } from 'zustand';

import type { StepThreeFormSchema } from '../validations/add-template.validation';
import type { UpdateTemplateFormSchema } from '../validations/edit-template.validation';

import { PopupType } from '../enums/popup-type.const';

export type UpdateTemplatePopupPayload = {
  documentName: string;
  fileLink: string;
  form: UpdateTemplateFormSchema;
};

type OpenPopupPayload = {
  mapFieldsStepThreeSnapshot?: null | StepThreeFormSchema;
  metadata?: string;
  onAcceptCallback: () => void;
  onDismissCallback?: () => void;
  type: PopupType;
  updatePayload?: null | UpdateTemplatePopupPayload;
};

type TemplatePopupStoreState = {
  clearMapFieldsStepThreeSnapshot: () => void;
  handleAccept: () => void;
  handleDismiss: () => void;
  mapFieldsStepThreeSnapshot: null | StepThreeFormSchema;
  metadata: null | string;
  onAcceptCallback?: () => void;
  onDismissCallback?: () => void;
  open: boolean;
  openPopup: (payload: OpenPopupPayload) => void;
  type: PopupType;
  updatePayload: null | UpdateTemplatePopupPayload;
};

const INITIAL_STATE: Omit<
  TemplatePopupStoreState,
  'clearMapFieldsStepThreeSnapshot' | 'handleAccept' | 'handleDismiss' | 'openPopup'
> = {
  mapFieldsStepThreeSnapshot: null,
  metadata: null,
  onAcceptCallback: undefined,
  onDismissCallback: undefined,
  open: false,
  type: PopupType.DELETE_TEMPLATE,
  updatePayload: null,
};

export const TemplatePopupStore = create<TemplatePopupStoreState>()((set, get) => ({
  ...INITIAL_STATE,

  clearMapFieldsStepThreeSnapshot: () => {
    set({ mapFieldsStepThreeSnapshot: null });
  },

  handleAccept: () => {
    const callback = get().onAcceptCallback;
    callback?.();
    set(INITIAL_STATE);
  },

  handleDismiss: () => {
    const callback = get().onDismissCallback;
    callback?.();
    set(INITIAL_STATE);
  },

  openPopup: ({
    type,
    metadata,
    onAcceptCallback,
    onDismissCallback,
    updatePayload,
    mapFieldsStepThreeSnapshot,
  }) => {
    set({
      mapFieldsStepThreeSnapshot: mapFieldsStepThreeSnapshot ?? null,
      metadata: metadata ?? null,
      onAcceptCallback,
      onDismissCallback,
      open: true,
      type,
      updatePayload: updatePayload ?? null,
    });
  },
}));
